import { render } from "./SearchSummary.vue?vue&type=template&id=ef24ce74&scoped=true"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"

import "./SearchSummary.vue?vue&type=style&index=0&id=ef24ce74&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef24ce74"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QDrawer,QCard,QBtn});qInstall(script, 'directives', {ClosePopup});
